<div class="el-breadcrumb-wrapper">
    <div class="container ">
        <!-- <div class="el-breadcrmb-inner  ">
      <h1 style="color: #e04787;">Edit User</h1>
      <ul>
        <li class="ms-3">
          <a [routerLink]="['/dashboard']" style="color: #e04787;"><i class="fa fa-reply " aria-hidden="true"></i>
            Back</a>
        </li>
      </ul>
    </div> -->
    </div>
</div>







<!-- Contact Section Start -->
<div class="el-contact-wrapper">
    <div class="container">
        <div class="el-contact-flex pt--4">
            <div class="col-lg-5">

                <div class="el-contact-left-flex">
                    <div class="el-contact-left-image">
                        <img src="../assets/images/all-instructor/contact-image.png" alt="Image"
                            class="el-contact-image">
                    </div>
                    <div class="el-contact-form-box" style="min-width: 100%;"><img
                            src="../assets/images/all-instructor/star-smile.png" alt="star" class="el-star-smile">



                        <form [formGroup]="object" (ngSubmit)="UpdateUser()">
                            <div class="error">
                                <div class="el-input-field mt-5">
                                     <label>User Name <span class="text-danger">*</span></label>
                                    <input type="text" placeholder="User Name" formControlName="username">
                                    <div *ngIf="object.get('username')?.touched && object.get('username')?.invalid">
                                        <small *ngIf="object.get('username')?.errors?.['required']">Username is
                                            required.</small>
                                        <small *ngIf="object.get('username')?.errors?.['minlength']">Minimum 3
                                            characters required.</small>
                                    </div>
                                </div>

                                <div class="el-input-field">
                                    <label>Mobile <span class="text-danger">*</span></label>
                                    <input type="text" placeholder="Mobile Number" formControlName="mobile">
                                    <div *ngIf="object.get('mobile')?.touched && object.get('mobile')?.invalid">
                                        <small *ngIf="object.get('mobile')?.errors?.['required']">Mobile number is
                                            required.</small>
                                        <small *ngIf="object.get('mobile')?.errors?.['pattern']">Enter a valid 10-digit
                                            number.</small>
                                    </div>
                                </div>

                                <div class="el-input-field">
                                      <label>Password <span class="text-danger">*</span></label>
                                    <input type="text" placeholder="Password" formControlName="password">
                                   <div *ngIf="object.get('password')?.touched && object.get('password')?.invalid">
                                        <small *ngIf="object.get('password')?.errors?.['required']">Password is
                                            required.</small>
                                        <small *ngIf="object.get('password')?.errors?.['minlength']">Minimum 3
                                            characters required.</small>
                                    </div>
                                    <div *ngIf="isloginwithSocial">

                                        <span class="text-danger">
                                            Your password is managed by Google since you chose to sign in with your Google account. Please use the Google sign-in option to log in to PowerPrep.
                                        </span>
                                    </div>
                                </div>

                                <div class="el-input-field">
                                    <div class="d-flex justify-content-between align-items-center">
                                     
                                            <button type="submit" [routerLink]="['/dashboard']" class="el-btn">Back</button>
                                            <button type="submit" [disabled]="object.invalid" class="el-btn">Update</button>
                                      
                                    </div>
                                </div>
                            </div>
                        </form>





                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Contact Section End -->